import React from "react";
import { Box, Typography } from "@mui/material";
import Whitelogo from "../../Assets/Whitelogo.png";
import TopVector from "../../Assets/TopVector.png";
import BottomVector from "../../Assets/BottomVector.png";

const MarketeersBackground = () => {
  const commonStyles = {
    fontWeight: "bold",
    mt: 1,
  };
  return (
    <Box
      sx={{
        backgroundColor: "#00205B",
        color: "white",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        textAlign: "center",
        position: "relative",
      }}
    >
      <Box sx={{ mb: 4 }}>
        <img
          src={Whitelogo}
          alt="Marketeers Logo"
          style={{ width: "50%", height: "10%", objectFit: "cover" }}
        />
      </Box>

      <>
        <Typography variant="h4" sx={{ ...commonStyles, mt: 0 }}>
          Empowering Data-Driven Decisions
        </Typography>

        <Typography variant="h5" sx={commonStyles}>
          with Agility
        </Typography>

        <Typography variant="h5" sx={commonStyles}>
          Through Smart{" "}
          <Box component="span" sx={{ color: "red", fontWeight: "bold" }}>
            Value
          </Box>
          ™ Platform
        </Typography>
      </>

      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "70px",
          height: "70px",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "120px",
            height: "120px",
            border: "15px solid white",
            borderRadius: "50%",
            position: "absolute",
            top: "-50px",
            right: "-50px",
          }}
        />
      </Box>

      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: { xs: "150px", md: "200px" },
          height: "auto",
        }}
      >
        <img
          src={BottomVector}
          alt="Bottom Vector"
          style={{ width: "65%", height: "auto", display: "block" }}
        />
      </Box>
    </Box>
  );
};
export default MarketeersBackground;
